import LoginFormEnhancedComponent from 'components/auth/LoginForm/container';

export default LoginFormEnhancedComponent;
